import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';

const MyProfile =() => {
    return(
      <>
     <Breadcrumb />
      <Typography>
        MyProfile works
       </Typography>
       </>
       );
};
export default MyProfile;